import type { Field } from 'react-querybuilder';
import { toFullOption } from 'react-querybuilder';
import { useCountryListQuery } from 'store/slices/rule/rule-entities-enum';
import type { FlexibleOptionList } from 'react-querybuilder/dist/types/types/options';
import { dayOfWeek } from 'types/rule/day-of-week';

const Fields = () => {
    const { data: countryList } = useCountryListQuery();

    const formattedCountryList: FlexibleOptionList<{
        value?: string;
        label: string;
        disabled?: boolean;
        name: string;
    }> =
        countryList?.map((country) => ({
            label: country.name,
            value: country.id,
            name: country.id,
            disabled: country.id === 'false',
        })) || [];

    const formattedDayList: FlexibleOptionList<{
        value?: any;
        label: string;
        disabled?: boolean;
        name: any;
    }> =
        dayOfWeek?.map((country) => ({
            label: country.label,
            value: country.value,
            name: country.value,
            disabled: country.label === 'false',
        })) || [];

    const fields: Field[] = [
        {
            name: 'date',
            label: 'Birth Date',
            inputType: 'date',
            datatype: 'date',
        },
        {
            name: 'day-of-week',
            label: 'DayOfWeek',
            valueEditorType: 'select',
            values: formattedDayList,
            defaultValue: 1,
        },
        {
            name: 'country-ids',
            label: 'Country Ids',
            valueEditorType: 'multiselect',
            values: formattedCountryList,
            defaultValue: '60e9de1e-81c7-4df5-852f-5037dbbbd8a2',
        },
        {
            name: 'user-ids',
            label: 'User',
        },
    ];

    return fields.map((field) => toFullOption(field));
};

export default Fields;
